import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from '@/translations';
import Backend from 'i18next-localstorage-cache';
import vars from '@/config/vars';
import { DEFAULT_LANGUAGE, getLanguageFromPath } from '@/helpers/language';

const initI18n = async () => {
  const lng = getLanguageFromPath(window.location.pathname);

  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      resources,
      lng,
      fallbackLng: DEFAULT_LANGUAGE,
      debug: vars.i18n,
      interpolation: {
        escapeValue: false,
      },
    });
};

initI18n();

export default i18n;
